import { createNativeStackNavigator } from '@react-navigation/native-stack';
import React from 'react';
import { SafeAreaView, StyleSheet } from 'react-native';
import i18n from '~/i18n';
import AddFundsScreen from '../screens/AddFundsScreen';
import ChangePasswordScreen from '../screens/ChangePasswordScreen';
import MoreScreen from '../screens/MoreScreen';
import SettingsScreen from '../screens/SettingsScreen';
import VerificationCenterScreen from '../screens/VerificationCenterScreen';
import WithdrawFundsScreen from '../screens/WithdrawFundsScreen';
import CustomHeader from './CustomHeader';
import NotificationsSettingsScreen from '../screens/NotificationsSettingsScreen';
import { useStyles } from '~/hooks';
import AddFundsCategoryScreen from '../screens/AddFundsCategoryScreen';
import AddFundsAlternativeScreen from '../screens/AddFundsAlternativeScreen';
import AddFundsBankScreen from '../screens/AddFundsBankScreen';
import AddFundsCardScreen from '../screens/AddFundsCardScreen';
import AddFundsCardPaymentProvider1Screen from '../screens/AddFundsCardPaymentProvider1Screen';
import AddFundsAlternativePaymentScreen from '../screens/AddFundsAlternativePaymentScreen';
import UploadDocumentsScreen from '../screens/UploadDocumentsScreen';
import ClientReportScreen from '../screens/ClientReportScreen';
import AccountsScreen from '../screens/AccountsScreen';
import ResultReportScreen from '../screens/ResultReportScreen';
import SwapReportScreen from '../screens/SwapReportScreen';
import AddFundsCardPaytikoScreen from "~/components/screens/AddFundsCardPaytikoScreen";
import AddFundsCardPaymentProvider1SelectScreen from "~/components/screens/AddFundsCardPaymentProvider1SelectScreen";
import LegalDocumentsScreen from '../screens/LegalDocumentsScreen';
import TermsOfBusinessScreen from '../screens/TermsOfBusinessScreen';
import OrderExecutionPolicyScreen from '../screens/OrderExecutionPolicyScreen';
import RiskDisclosureNoticeScreen from '../screens/RiskDisclosureNoticeScreen';
import PrivacyPolicyScreen from '../screens/PrivacyPolicyScreen';
import CopyTradingAgreementScreen from '../screens/CopyTradingAgreementScreen';


const Stack = createNativeStackNavigator();

export default function MoreStackNavigator() {
    const styles = useStyles(stylesGenerator);

    return (
        <SafeAreaView style={styles.container}>
            <Stack.Navigator initialRouteName="More">
                <Stack.Screen
                    name="More"
                    key={'More'}
                    component={MoreScreen}
                    options={{
                        title: i18n.t('more-screen'),
                        header: () => <CustomHeader title={'more-screen'} hideBackButton={true} />,
                    }}
                />
                <Stack.Screen
                    name="Settings"
                    key={'Settings'}
                    component={SettingsScreen}
                    options={{
                        title: i18n.t('settings-screen'),
                        header: () => <CustomHeader title={'settings-screen'} />,
                    }}
                />
                <Stack.Screen
                    name="Accounts"
                    key={'Accounts'}
                    component={AccountsScreen}
                    options={{
                        title: i18n.t('accounts-label'),
                        header: () => <CustomHeader title={'accounts-label'} />,
                    }}
                />
                <Stack.Screen
                    name="ChangePassword"
                    key={'ChangePassword'}
                    component={ChangePasswordScreen}
                    options={{
                        header: () => <CustomHeader title={'change-password'} />,
                    }}
                />
                <Stack.Screen
                    name="NotificationsSettings"
                    key={'NotificationsSettings'}
                    component={NotificationsSettingsScreen}
                    options={{
                        header: () => <CustomHeader title={'notifications-label'} />,
                    }}
                />
                <Stack.Screen
                    name="WithdrawFunds"
                    key={'WithdrawFunds'}
                    component={WithdrawFundsScreen}
                    options={{
                        header: () => <CustomHeader title={'withdraw-funds-screen'} />,
                    }}
                />
                <Stack.Screen
                    name="UploadDocuments"
                    key={'UploadDocuments'}
                    component={UploadDocumentsScreen}
                    options={{
                        header: () => <CustomHeader title={'upload-documents'} />,
                    }}
                />
                <Stack.Screen
                    name="AddFunds"
                    key={'AddFunds'}
                    component={AddFundsScreen}
                    options={{
                        header: () => <CustomHeader title={'add-money-screen'} />,
                    }}
                />
                <Stack.Screen
                    name="AddFundsCategory"
                    key={'AddFundsCategory'}
                    component={AddFundsCategoryScreen}
                    options={{
                        header: () => <CustomHeader title={'add-money-screen'} />,
                    }}
                />
                <Stack.Screen
                    name="AddFundsCard"
                    key={'AddFundsCard'}
                    component={AddFundsCardScreen}
                    options={{
                        header: () => <CustomHeader title={'add-money-screen'} />,
                    }}
                />
                <Stack.Screen
                    name="AddFundsCardPaymentProvider1"
                    key={'AddFundsCardPaymentProvider1'}
                    component={AddFundsCardPaymentProvider1Screen}
                    options={{
                        header: () => <CustomHeader title={'add-money-screen'} />,
                    }}
                />
                <Stack.Screen
                    name="AddFundsCardPaytiko"
                    key={'AddFundsCardPaytiko'}
                    component={AddFundsCardPaytikoScreen}
                    options={{
                        header: () => <CustomHeader title={'add-money-screen'} />,
                    }}
                />
                <Stack.Screen
                    name="AddFundsCardPaymentProvider1Select"
                    key={'AddFundsCardPaymentProvider1Select'}
                    component={AddFundsCardPaymentProvider1SelectScreen}
                    options={{
                        header: () => <CustomHeader title={'add-money-screen'} />,
                    }}
                />
                <Stack.Screen
                    name="AddFundsAlternativePayment"
                    key={'AddFundsAlternativePayment'}
                    component={AddFundsAlternativePaymentScreen}
                    options={{
                        header: () => <CustomHeader title={'add-money-screen'} />,
                    }}
                />
                <Stack.Screen
                    name="AddFundsAlternative"
                    key={'AddFundsAlternative'}
                    component={AddFundsAlternativeScreen}
                    options={{
                        header: () => <CustomHeader title={'add-money-screen'} />,
                    }}
                />
                <Stack.Screen
                    name="AddFundsBank"
                    key={'AddFundsBank'}
                    component={AddFundsBankScreen}
                    options={{
                        header: () => <CustomHeader title={'add-money-screen'} />,
                    }}
                />
                <Stack.Screen
                    name="VerificationCenter"
                    key={'VerificationCenter'}
                    component={VerificationCenterScreen}
                    options={{
                        header: () => <CustomHeader title={'verification-center-screen'} />,
                    }}
                />
                <Stack.Screen
                    name="ClientReport"
                    key={'ClientReport'}
                    component={ClientReportScreen}
                    options={{
                        header: () => <CustomHeader title={'client-report'} />,
                        title: i18n.t('client-report')
                    }}
                />
                <Stack.Screen
                    name="ResultReport"
                    key={'ResultReport'}
                    component={ResultReportScreen}
                    options={{
                        header: () => <CustomHeader title={'result-report'} />,
                        title: i18n.t('result-report')
                    }}
                />
                <Stack.Screen
                    name="SwapReport"
                    key={'SwapReport'}
                    component={SwapReportScreen}
                    options={{
                        header: () => <CustomHeader title={'swap-report'} />,
                        title: i18n.t('swap-report')
                    }}
                />
                <Stack.Screen
                    name="LegalDocuments"
                    key={'LegalDocuments'}
                    component={LegalDocumentsScreen}
                    options={{
                        header: () => <CustomHeader title={'legal-documents'} />,
                        title: i18n.t('legal-documents')
                    }}
                />
                <Stack.Screen
                    name="TermsOfBusiness"
                    key={'TermsOfBusiness'}
                    component={TermsOfBusinessScreen}
                    options={{
                        header: () => <CustomHeader title={'terms-of-business'} />,
                        title: i18n.t('terms-of-business')
                    }}
                />
                <Stack.Screen
                    name="OrderExecutionPolicy"
                    key={'OrderExecutionPolicy'}
                    component={OrderExecutionPolicyScreen}
                    options={{
                        header: () => <CustomHeader title={'order-execution-policy'} />,
                        title: i18n.t('order-execution-policy')
                    }}
                />
                <Stack.Screen
                    name="RiskDisclosureNotice"
                    key={'RiskDisclosureNotice'}
                    component={RiskDisclosureNoticeScreen}
                    options={{
                        header: () => <CustomHeader title={'risk-disclosure-notice'} />,
                        title: i18n.t('risk-disclosure-notice')
                    }}
                />
                <Stack.Screen
                    name="PrivacyPolicy"
                    key={'PrivacyPolicy'}
                    component={PrivacyPolicyScreen}
                    options={{
                        header: () => <CustomHeader title={'privacy-policy'} />,
                        title: i18n.t('privacy-policy')
                    }}
                />
                <Stack.Screen
                    name="CopyTradingAgreement"
                    key={'CopyTradingAgreement'}
                    component={CopyTradingAgreementScreen}
                    options={{
                        header: () => <CustomHeader title={'copy-trading-agreement'} />,
                        title: i18n.t('copy-trading-agreement')
                    }}
                />
            </Stack.Navigator>
        </SafeAreaView>
    );
}

const stylesGenerator = () =>
    StyleSheet.create({
        container: {
            flex: 1,
        },
    });
